import moment from 'moment'

import { translate } from '~/core/translate'

const COUNTDOWN_INTERVAL = 45 * 60 * 1000
const UPCOMING_INTERVAL = 10 * 60 * 1000

export const dayInMilliSecs = 24 * 60 * 60 * 1000

export const getRandomThirtyMinutesIntervalMs = () => Math.ceil(Math.random() * 30 * 60 * 1000)

export const getStartOfToday = () => moment().startOf('day')

export const getEndOfDay = day => moment(day).endOf('day')

export const getMilisecondsUntilTomorrow = () => {
  const now = moment()
  return getEndOfDay(now) - now
}

export const formatHeaderDate = (date, numberOfDays) =>
  moment(date).calendar(moment(), {
    sameDay: `[${translate('today')}], MMMM DD`,
    nextDay: () => {
      if (numberOfDays) {
        return `MMMM DD [- ${moment(date)
          .add(numberOfDays, 'day')
          .format('MMMM DD')}]`
      }
      return 'MMMM DD'
    },
    lastDay: `[${translate('yesterday')}], MMMM DD`,
    nextWeek: 'MMMM DD',
    lastWeek: 'MMMM DD',
    sameElse: 'MMMM DD'
  })

export const getEventReadableTime = (start, end, isAllDay, dayStart) => {
  if (isAllDay) {
    return translate('all_day')
  }

  let s
  let e

  const dayEnd = getEndOfDay(dayStart)

  if (dayStart > start || dayEnd <= end) {
    const str = 'MMM DD, LT'

    s = moment(start).format(str)
    e = moment(end).format(str)
  } else {
    s = moment(start).format('LT')
    e = moment(end).format('LT')
  }

  return `${s} ― ${e}`
}

export const getEventCountDown = (start, end, isAllDay) => {
  if (isAllDay) {
    return translate('all_day')
  }

  const now = Date.now()

  if (now > end) {
    return ''
  }

  if (now >= start) {
    return translate('now')
  }

  if (start <= now + COUNTDOWN_INTERVAL) {
    const min = Math.floor((start - now) / (60 * 1000))

    if (!min) {
      return translate('now')
    }

    return translate('in_x_minutes', { number: min })
  }

  return ''
}

export const checkUpcoming = (start, end) => {
  const now = Date.now()
  return now < end && (now + UPCOMING_INTERVAL) >= start
}

export const getMomentDate = date => moment(date)

export const formatChatTimestamp = timestamp =>
  moment(timestamp).format('LT')

export const formatTranscriptTimestamp = timestamp =>
  moment(timestamp).format('LT')

/**
 * Method that formats the time at which screenshots are captured in a meeting.
 * Current consensus is for the information to be passed as seconds, but this may change in the future.
 *
 * @param {number} timestamp - the second at which a screenshot was captured in the meeting.
 * @returns {string}
 */
export const formatScreenshotTimestamp = timestamp =>
  moment(timestamp).format('LT')

export const isToday = date => moment(date).isSame(moment(), 'day')

export const getDuration = miliseconds => {
  if (!miliseconds) {
    return ''
  }

  const duration = moment.duration(miliseconds)
  const hours = duration.hours()
  const minutes = duration.minutes()
  const seconds = duration.seconds()
  const showMinutes = hours || minutes
  const showSeconds = hours || minutes || seconds

  return [hours && `${hours}h`, showMinutes && `${minutes}min`, showSeconds && `${seconds}s`]
    .filter(Boolean)
    .join(' ')
}
